import React from "react";
import {Form} from "react-bootstrap";
import DatePickerField from "../Statistics/DatePickerField.jsx";
import SelectList from "../SelectList.jsx";
import {BEREICHE} from "./format.js";

const PRESETS = [
    {id: "heute", label: "Heute"},
    {id: "7d", label: "7 Tage"},
    {id: "30d", label: "30 Tage"},
    {id: "quartal", label: "Quartal"},
    {id: "frei", label: "Frei wählbar"},
];

/**
 * Gemeinsame Filterleiste der Nutzungsauswertung - Vorbild ist
 * SalesFilterHeader/FilterBar aus der Verkaufsstatistik: Seitentitel,
 * Zeitraum-Schnellwahl mit frei wählbarem Von/Bis, dazu Mitarbeiter- und
 * Bereichsauswahl (beide als selbst gestaltete Auswahlliste, kein
 * natives <select> - siehe globale Vorgabe). Mitarbeiter- und
 * Bereichsauswahl lassen sich abschalten, z. B. für das Profil, das
 * bereits auf einen Mitarbeiter festgelegt ist.
 */
export default function NutzungFilter({title, nutzungFilters, showMitarbeiter = true, showBereich = true, children}) {
    const {
        preset,
        selectPreset,
        von,
        bis,
        changeVon,
        changeBis,
        userId,
        setUserId,
        bereich,
        setBereich,
        employeeOptions,
    } = nutzungFilters;

    const mitarbeiterOptions = [{value: "", label: "Alle Mitarbeiter"}, ...employeeOptions];
    const bereichOptions = [{value: "", label: "Alle Bereiche"}, ...BEREICHE];

    return (
        <>
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-2">
                <h1 className="h4 mb-0">{title}</h1>
            </div>

            <div className="mb-3">
                <div className="d-flex flex-wrap align-items-end gap-3">
                    <div
                        className="d-inline-flex align-items-stretch p-1 rounded-pill bg-body-secondary flex-wrap"
                        role="group"
                        aria-label="Zeitraum-Schnellwahl"
                    >
                        {PRESETS.map((item) => (
                            <button
                                key={item.id}
                                type="button"
                                aria-pressed={preset === item.id}
                                className={`btn btn-sm rounded-pill border-0 ${preset === item.id ? "bg-white text-body shadow-sm fw-semibold" : "text-body"}`}
                                style={{padding: ".3rem .9rem"}}
                                onClick={() => selectPreset(item.id)}
                            >
                                {item.label}
                            </button>
                        ))}
                    </div>

                    <div className="d-flex align-items-end gap-2">
                        <div>
                            <Form.Label className="small text-muted mb-1" htmlFor="nutzung-date-from">Von</Form.Label>
                            <DatePickerField
                                id="nutzung-date-from"
                                label="Zeitraum von"
                                size="sm"
                                value={von}
                                max={bis}
                                onChange={changeVon}
                                style={{width: 148}}
                            />
                        </div>
                        <div>
                            <Form.Label className="small text-muted mb-1" htmlFor="nutzung-date-to">Bis</Form.Label>
                            <DatePickerField
                                id="nutzung-date-to"
                                label="Zeitraum bis"
                                size="sm"
                                value={bis}
                                min={von}
                                onChange={changeBis}
                                style={{width: 148}}
                            />
                        </div>
                    </div>

                    {showMitarbeiter && (
                        <div>
                            <Form.Label className="small text-muted mb-1" htmlFor="nutzung-mitarbeiter">Mitarbeiter</Form.Label>
                            <SelectList
                                id="nutzung-mitarbeiter"
                                size="sm"
                                value={userId}
                                options={mitarbeiterOptions}
                                onChange={setUserId}
                                ariaLabel="Mitarbeiter"
                                style={{minWidth: 220}}
                            />
                        </div>
                    )}

                    {showBereich && (
                        <div>
                            <Form.Label className="small text-muted mb-1" htmlFor="nutzung-bereich">Bereich</Form.Label>
                            <SelectList
                                id="nutzung-bereich"
                                size="sm"
                                value={bereich}
                                options={bereichOptions}
                                onChange={setBereich}
                                ariaLabel="Bereich"
                                style={{minWidth: 200}}
                            />
                        </div>
                    )}
                </div>
            </div>

            {children}
        </>
    );
}
